module.exports = __webpack_public_path__ + "img/temperature-full.1a355f0c.svg";